module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ssp_color":"SSP Color"},"ja":{"ssp_color":"SSP色調整"}}')
  delete Component.options._Ctor
}
